"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BentoPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const blueprint_1 = require("@groma-dev/blueprint");
const BentoPanel_module_scss_1 = __importDefault(require("./BentoPanel.module.scss"));
/**
 * BentoPanel is the wrapping component for the BentoPanel options to be used in the header.
 * This component wraps the `<DrawerPanel />` component from Blueprint
 * @param props
 * @constructor
 */
const BentoPanel = (props) => {
    const { anchor, children, className, disableScroll, onClose, open, testId, variant = blueprint_1.DrawerPanelVariant.Takeover } = props, args = __rest(props, ["anchor", "children", "className", "disableScroll", "onClose", "open", "testId", "variant"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, args, { className: (0, blueprint_1.classNames)('Header-bentoPanel-local', className, BentoPanel_module_scss_1.default.panel), children: (0, jsx_runtime_1.jsx)(blueprint_1.DrawerPanel, { anchor: anchor, disableScroll: disableScroll, id: "bentoPanel", onClose: onClose, open: open, testId: testId, variant: variant, children: children }) })));
};
exports.BentoPanel = BentoPanel;
